import React from "react";
import firebase from "firebase/compat/app";
import moment from "moment";
import "firebase/firestore";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import ToastView, { defaultToastProps } from "../components/newcomponents/ToastView";
import texts from "./texts";

import hospital from "../images/iconsNotif/hospital.svg";

// Common Icons

import textIcon from "../images/media-icons-new/icons/text.svg";
import textIconProvider from "../images/media-icons-new/icons-providers/text.svg";

import audio from "../images/media-icons-new/icons/audio.svg";
import audioProvider from "../images/media-icons-new/icons-providers/audio.svg";

import document from "../images/media-icons-new/icons/docs.svg";
import documentProvider from "../images/media-icons-new/icons-providers/docs.svg";

import pdf from "../images/media-icons-new/icons/docs.svg";
import pdfProvider from "../images/media-icons-new/icons-providers/docs.svg";

import image from "../images/media-icons-new/icons/image.svg";
import imageProvider from "../images/media-icons-new/icons-providers/image.svg";

import video from "../images/media-icons-new/icons/video.svg";
import videoProvider from "../images/media-icons-new/icons-providers/video.svg";

import folderNew from "../images/profileSection/activity-icon.svg";
import folderNewProvider from "../images/profileSection/provider-icon.svg";

import five from "../images/library/new (5).svg";
import { allowedFormats } from "../Constants/pendoComponentIds/formats";
import { ShowAlert } from "../common/alert";
import data from "../I18n/en.json";

// dashboard icons
import imageIcon from "../images/media-icons-new/icons-dashboard/image.svg";
import imageIconProvider from "../images/media-icons-new/icons-dashboard-providers/image.svg";

import audioIcon from "../images/media-icons-new/icons-dashboard/audio.svg";
import audioIconProvider from "../images/media-icons-new/icons-dashboard-providers/audio.svg";

import videoIcon from "../images/media-icons-new/icons-dashboard/video.svg";
import videoIconProvider from "../images/media-icons-new/icons-dashboard-providers/video.svg";

import txtIcon from "../images/media-icons-new/icons-dashboard/text.svg";
import txtIconProvider from "../images/media-icons-new/icons-dashboard-providers/text.svg";

import pdfIcon from "../images/media-icons-new/icons-dashboard/docs.svg";
import pdfIconProvider from "../images/media-icons-new/icons-dashboard-providers/docs.svg";
import axios from "axios";

// window.firestore = firebase?.firestore();

export let greyBtnCls = "bg-light-grey-100 text-black text-small w-xsmall h-xsmall round-border-s font-weight-bold";
export let redBtnCls = "bg-white text-danger text-small w-xsmall h-xsmall round-border-s font-weight-bold";
export let blueBtnCls = "btn-default bg-prime text-white text-small w-xsmall h-xsmall round-border-s font-weight-bold";
var urlRegex =
   /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\00a1\ffff0-9]-*)*[a-z\00a1\ffff0-9]+)(?:\.(?:[a-z\00a1\ffff0-9]-*)*[a-z\00a1\ffff0-9]+)*(?:\.(?:[a-z\00a1\ffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/gm;


// const engagePortals = ["provider.playbackhealth.com", "dev-admin.playbackapi.com", "provider-uat.playbackhealth.com"]
// const proPortals = ["pro.playbackhealth.com", "dev-provider-pro.playback-dev.com"]

const checkEngageOrPro = () => {
   if (localStorage.getItem("isEngageApp") === "true" && window.location.host === "provider-uat.playbackhealth.com") return false
   else if (localStorage.getItem("isEngageApp") === "false" && window.location.host === "provider-uat.playbackhealth.com") return true
   else return process.env.REACT_APP_IS_NEW_APP || false
}
export const isNewApp = checkEngageOrPro()

export const getMediaIconNew = (fileType, getHospital, hospitalId, isProviderOnlyContent = false) => {
   if (getHospital) {
      if (hospitalId) {
         return `${process.env.REACT_APP_PROFILE_URL}/${hospitalId}`;
      } else {
         return hospital;
      }
   }
   if (fileType?.includes("image")) {
      return !isProviderOnlyContent ? image : imageProvider;
   } else if (fileType?.includes("audio")) {
      return !isProviderOnlyContent ? audio : audioProvider;
   } else if (fileType?.includes("pdf")) {
      return !isProviderOnlyContent ? pdf : pdfProvider;
   } else if (fileType?.includes("application")) {
      return !isProviderOnlyContent ? document : documentProvider;
   } else if (fileType?.includes("video")) {
      return !isProviderOnlyContent ? video : videoProvider;
   } else if (
      fileType?.includes("txt") ||
      fileType?.includes("text") ||
      fileType === null ||
      fileType === undefined ||
      fileType?.includes("content")
   ) {
      return !isProviderOnlyContent ? textIcon : textIconProvider;
   } else if (fileType?.includes("folder") || fileType?.includes("directory")) {
      return five;
   } else return !isProviderOnlyContent ? document : documentProvider;
};

export const getMediaIconNotes = (fileType, getHospital, hospitalId, isProviderOnlyContent = false) => {
   if (getHospital) {
      if (hospitalId) {
         return `${process.env.REACT_APP_PROFILE_URL}/${hospitalId}`;
      } else {
         return hospital;
      }
   }
   if (fileType?.includes("image")) {
      return !isProviderOnlyContent ? image : imageProvider;
   } else if (fileType?.includes("audio")) {
      return !isProviderOnlyContent ? audio : audioProvider;
   } else if (fileType?.includes("pdf")) {
      return !isProviderOnlyContent ? pdf : pdfProvider;
   } else if (fileType?.includes("application")) {
      return !isProviderOnlyContent ? document : documentProvider;
   } else if (fileType?.includes("video")) {
      return !isProviderOnlyContent ? video : videoProvider;
   } else if (
      fileType?.includes("txt") ||
      fileType?.includes("text") ||
      fileType === null ||
      fileType === undefined ||
      fileType?.includes("content")
   ) {
      return !isProviderOnlyContent ? textIcon : textIconProvider;
   } else if (fileType?.includes("folder") || fileType?.includes("directory")) {
      return !isProviderOnlyContent ? folderNewProvider : folderNew;
   } else return !isProviderOnlyContent ? document : documentProvider;
};

export const checkRecentUpdateIcon = (type, isProviderOnlyContent = false) => {
   if (type?.includes("image")) {
      return isProviderOnlyContent ? imageIconProvider : imageIcon;
   } else if (type?.includes("audio")) {
      return isProviderOnlyContent ? audioIconProvider : audioIcon;
   } else if (type?.includes("video")) {
      return isProviderOnlyContent ? videoIconProvider : videoIcon;
   } else if (type?.includes("text") || type?.includes("referral") || type?.includes("item")) {
      return isProviderOnlyContent ? txtIconProvider : txtIcon;
   } else if (type?.includes("pdf")) {
      return isProviderOnlyContent ? pdfIconProvider : pdfIcon;
   } else {
      return isProviderOnlyContent ? pdfIconProvider : pdfIcon;
   }
};

export function findNodeById(nodes, id) {
   let res;

   function findNode(nodes, id) {
      for (let i = 0; i < nodes.length; i++) {
         if (nodes[i].id === id) {
            res = nodes[i];
            break;
         }
         if (nodes[i].children) {
            findNode(nodes[i].children, id);
         }
      }
   }
   findNode(nodes, id);

   return res;
}
export const fileTypes =
   "image/jpeg,image/jpg,image/png,video/mp4,video/quicktime,video/webm,audio/m4a,audio/x-m4a,audio/mp3,audio/mpeg,application/pdf";

// export const sepNameReg = /^[a-zA-Z ]{2,30}$/;
// export const nameRegex = /^[a-zA-Z]{2,}([\s]{1,}[a-zA-Z]{2,})?([\s]{1,}[a-zA-Z]{2,})$/;
export const sepNameReg = /^$/;
export const nameRegex = /(\w\s\w)/;
export const firstLastNameRegex = /(\w{2,}\s\w{2,})/;
export const nameRegexProfile = /(\w.+\s\w)/;
export const emailReg =
   /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const getFormattedDate = (unix) => {
   if (!unix) return "";
   if (window.dates && window.dates[unix]) {
      return window.dates[unix];
   }
   let unixDate = parseInt(unix);
   // var pattern = /(\d{4})(\d{2})(\d{2})/;
   let date = unix.replace(/(\d{4})(\d{2})(\d{2})/, "$2/$3/$1");
   // let date = new Date(unixDate).toLocaleDateString();
   if (!window.dates) {
      window["dates"] = {};
   }
   let str = unixDate.toString();
   window.dates[str] = date;
   return date;
};

export const getFormattedStampDate = (stampDate) => {
   if (!stampDate) return "";
   if (window.dates && window.dates[stampDate]) {
      return window.dates[stampDate];
   }
   let formatDate = new Date(stampDate);
   let date =
      formatDate.getMonth() +
      1 +
      "/" +
      formatDate.getDate() +
      "/" +
      formatDate.getFullYear() +
      " @ " +
      formatDate.toLocaleString("en-US", {
         hour: "numeric",
         hour12: true,
         minute: "numeric",
      });
   if (!window.dates) {
      window["dates"] = {};
   }
   window.dates[stampDate] = date;
   return date;
};

export const isValidEmail = (email) => {
   return emailReg.test(email);
};
export const isValidMob = (mobile) => {
   let mobReg = /^(\+1|)?(\d{3})(\d{3})(\d{4})$/;
   let areaReg = /^(\+254|)?(\d{3})(\d{3})(\d{3})$/;
   return areaReg.test(mobile) || mobReg.test(mobile);
};
export const cleanMobileNumber = (num) => {
   const str = String(num);
   const hasPlus = str.trimStart().startsWith("+");
   const digits = str.replace(/\D/g, "");
   return hasPlus ? `+${digits}` : digits;
}

export function formatPhoneNumber(phoneNumberString) {
   if (phoneNumberString?.length === 10) {
      phoneNumberString = "+1" + phoneNumberString;
   }
   if (!phoneNumberString) return "";
   if (window.phoneNumbers && window.phoneNumbers[phoneNumberString]) {
      return window.phoneNumbers[phoneNumberString];
   }
   if (!window.phoneNumbers) {
      window["phoneNumbers"] = {};
   }
   let number = phoneNumberString.replace(/(\+\d{1})(\d{3})(\d{3})(\d{4})/, "$1 ($2) $3-$4");
   window.phoneNumbers[phoneNumberString] = number;
   return number || "-";
}

window["initialColors"] = [
   "#FA9490",
   "#F9B198",
   "#BED6E0",
   "#AED6B3",
   "#C0C0C0",
   "#A36361",
   "#D3A29D",
   "#EECC8C",
   "#9EABA2",
   "#7277F4",
];

String.prototype.mobileInputMaskValue = function () {
   let rawVal = this.replace(/(\+\d{1})\s\((\d{3})\)\s(\d{3})\-(\d{4})/, "$1$2$3$4");
   return rawVal;
};

export const checkIconType = (iconObject) => {
   if (iconObject?.type === "media" || iconObject?.type === "content") {
      let type = iconObject.fileType?.split("/")[1];
      if (iconObject?.fileType.includes("image")) {
         return `/assets/images/newimages/content-icons/${type}-icon.svg`;
      } else if (iconObject?.fileType.includes("audio")) {
         return `/assets/images/newimages/content-icons/mp3-icon.svg`;
      } else if (iconObject?.fileType.includes("video")) {
         return `/assets/images/newimages/content-icons/${type}-icon.svg`;
      } else if (iconObject?.fileType.includes("pdf")) {
         return `/assets/images/newimages/content-icons/${type}-icon.svg`;
      } else if (iconObject?.fileType.includes("webhook")) {
         return "/assets/images/webhook-icon.svg";
      }
   } else if (iconObject?.type === "item") {
      return "/assets/images/newimages/content-icons/text-icon.svg";
   } else if (iconObject?.type === "careTeam" || iconObject?.type === "care") {
      return "/assets/images/newimages/content-icons/careteam-icon.svg";
   } else if (iconObject?.type === "bundle") {
      return "/assets/images/bundle-icon.svg";
   } else if (iconObject?.type === "referral") {
      return "/assets/images/referral-icon.svg";
   }
   return "/assets/images/newimages/content-icons/careteam-icon.svg";
};

// export const getMediaIcon = (fileType) => {
//   let type = fileType?.split("/")[1];
//   if (fileType?.includes("audio")) {
//     return "/assets/images/newimages/content-icons/mp3-icon.svg";
//   } else if (fileType?.includes("item")) {
//     return "/assets/images/newimages/content-icons/text-icon.svg";
//   } else if (fileType?.includes("svg")) {
//     return "/assets/images/newimages/content-icons/svg-icon.svg";
//   } else if (type === "pptx") {
//     return "/assets/images/newimages/content-icons/ppt-icon.svg";
//   } else if (type === "docx") {
//     return "/assets/images/newimages/content-icons/doc-icon.svg";
//   } else if (type === "jpeg") {
//     return "/assets/images/newimages/content-icons/jpg-icon.svg";
//   } else if (fileType === "referral") {
//     return "/assets/images/newimages/content-icons/referral-icon.svg";
//   } else if (fileType.includes("video")) {
//     return "/assets/images/newimages/content-icons/mp4-icon.svg";
//   } else {
//     return `/assets/images/newimages/content-icons/${type}-icon.svg`;
//   }
// };

export const getMediaIcon = (fileType) => {
   let type = fileType?.split("/")[1];
   if (fileType?.includes("image")) {
      return "/assets/images/newimages/lib-image.svg";
   } else if (fileType?.includes("audio")) {
      return "/assets/images/newimages/lib-audio.svg";
   } else if (fileType?.includes("video")) {
      return "/assets/images/newimages/lib-video.svg";
   } else if (fileType?.includes("txt")) {
      return "/assets/images/newimages/lib-text.svg";
   } else if (fileType?.includes("pdf")) {
      return "/assets/images/newimages/lib-pdf.svg";
   } else {
      return "/assets/images/newimages/lib-doc.svg";
   }
};

window.getDateDiff = function (date1, date2, time) {
   let a = moment(date1);
   let b = moment(date2);
   return a.diff(b, time ? time : "seconds"); // 1
};

export const compareObjects = function (obj1, obj2) {
   let str1 = JSON.stringify(obj1);
   let str2 = JSON.stringify(obj2);
   return str1.localeCompare(str2);
};

export const getAgeFromDate = (date) => {
   if (date === "" || date === null || date === undefined) return "-";
   const date1 = date.includes("/") ? new Date(date) : new Date(moment(date, "YYYYMMDD").format("MM/DD/YYYY"));
   const date2 = new Date();
   const diffTime = Math.abs(date2 - date1);
   const diffDays = parseInt(Math.ceil(diffTime / (1000 * 60 * 60 * 24)) / 365) + " yrs";
   return diffDays === "0 yrs" ? "1 yrs" : diffDays;
};

var fulldays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const formatDate = (someDateTimeStamp) => {
   if (someDateTimeStamp === "" || someDateTimeStamp === null || someDateTimeStamp === undefined) return "-";
   var dt = new Date(someDateTimeStamp),
      date = dt.getDate(),
      diffDays = new Date().getDate() - date,
      diffMonths = new Date().getMonth() - dt.getMonth(),
      diffYears = new Date().getFullYear() - dt.getFullYear();

   if (diffYears === 0 && diffDays === 0 && diffMonths === 0) {
      return "Today";
   } else if (diffYears === 0 && diffDays === 1) {
      return "Yesterday";
   } else if (diffYears === 0 && diffDays < -1 && diffDays > -7) {
      return fulldays[dt.getDay()];
   } else {
      return getDateStringFormat(someDateTimeStamp);
   }
};

export const getDateStringFormat = (stampDate) => {
   if (!stampDate) return "";
   if (window.dates && window.dates[stampDate]) {
      return window.dates[stampDate];
   }
   let formatDate = new Date(stampDate);
   let date = formatDate.getMonth() + 1 + "/" + formatDate.getDate() + "/" + formatDate.getFullYear();
   if (!window.dates) {
      window["dates"] = {};
   }
   window.dates[stampDate] = date;
   return date;
};

export const calculateDateLabel = (dateValue, isRecentCard = false) => {
   const date = new Date(dateValue);
   let oneDate = moment(date);
   let dayName = oneDate.format("dddd");
   let diffInDays = Math.round(moment().diff(dateValue, "days", true));
   if (diffInDays > 1 && diffInDays < 7) {
      return dayName + " at " + moment(date).format(isRecentCard ? "hh:mm A" : "hh:mm a");
   } else if (diffInDays === 0) {
      return (dayName = "Today" + " at " + moment(date).format(isRecentCard ? "hh:mm A" : "hh:mm a"));
   } else if (diffInDays === 1) {
      return (dayName = "Yesterday" + " at " + moment(date).format(isRecentCard ? "hh:mm A" : "hh:mm a"));
   } else {
      return moment(date).format("MM/DD/YYYY") + " at " + moment(date).format(isRecentCard ? "hh:mm A" : "hh:mm a");
   }
};
export const calculateDateDay = (dateValue) => {
   const date = new Date(dateValue);
   let oneDate = moment(date);
   let dayName = oneDate.format("dddd");
   let diffInDays = Math.round(moment().diff(dateValue, "days", true));
   if (diffInDays > 1 && diffInDays < 8) {
      return dayName;
   } else if (diffInDays === 0) {
      return "Today";
   } else if (diffInDays === 1) {
      return "Yesterday";
   } else {
      return moment(date).format("MM/DD/YYYY");
   }
};
export const calculateDateLabelUTC = (dateValue) => {
   const date = new Date(dateValue + "Z").toString();
   let oneDate = moment(date);
   let dayName = oneDate.format("dddd");
   let diffInDays = Math.round(moment().diff(dateValue, "days", true));
   if (diffInDays > 1 && diffInDays < 8) {
      return dayName + " @ " + moment(date).format("hh:mm a");
   } else if (diffInDays === 0) {
      return (dayName = "Today" + " @ " + moment(date).format("hh:mm a"));
   } else if (diffInDays === 1) {
      return (dayName = "Yesterday" + " @ " + moment(date).format("hh:mm a"));
   } else {
      return moment(date).format("MM/DD/YYYY") + " @ " + moment(date).format("hh:mm a");
   }
};

export const ageForDob = (dateValue) => {
   if (!dateValue || dateValue === "-") return "-";
   let dobForAge = moment(dateValue);
   dobForAge = new Date(dobForAge);
   // dobForAge = moment().diff(dobForAge, "years");
   let ageLabel = "";
   let ageInDays = moment().diff(dobForAge, "days");
   let ageInWeeks = moment().diff(dobForAge, "weeks");
   let ageInMonths = moment().diff(dobForAge, "months");
   let ageInYears = moment().diff(dobForAge, "years");
   let ageinHours = moment().diff(dobForAge, "hours");
   if (ageInDays > 6 && ageInWeeks > 4 && ageInMonths >= 12) {
      return (ageLabel = ageInYears + "y");
   } else if (ageInDays > 6 && ageInDays > 30 && ageInMonths < 12) {
      return (ageLabel = ageInMonths + "m");
   } else if (ageInDays > 6 && ageInDays <= 30) {
      return (ageLabel = ageInDays + "d");
   } else if (ageInDays === 0) {
      return (ageLabel = ageinHours + "h");
   } else {
      return (ageLabel = ageInDays + "d");
   }
};
export const checkEmpty = (data) => {
   if (data === "" || data === null) return "-";

   return data;
};

export const checkEmptyParams = (data) => {
   if (data === "" || data === null) return "";

   return data;
};

export const RefetchApi = (callback) => {
   localStorage.setItem("libraryUploading", true);
   let count = 0;

   const myInterval = setInterval(myTimer, 5000);

   function myTimer() {
      let stopUpload = localStorage.getItem("stopUploading");

      if (stopUpload && stopUpload === "true") {
         myStopFunction();
         localStorage.removeItem("stopUploading");
         return;
      } else {
         callback();
         count = count + 10;
         // localStorage.setItem("libraryUploading", count + 10);
         if (count === 70) {
            myStopFunction();
         }
      }
   }

   function myStopFunction() {
      clearInterval(myInterval);
   }
};

export const formatUrl = (url) => {
   if (url.includes("@")) {
      return url.replaceAll(" ", "+");
   } else return url;
};

export function isSafari() {
   let userAgent = window.navigator.userAgent;
   let browserName;
   if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = "chrome";
   } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = "firefox";
   } else if (userAgent.match(/safari/i)) {
      browserName = "safari";
   } else if (userAgent.match(/opr\//i)) {
      browserName = "opera";
   } else if (userAgent.match(/edg/i)) {
      browserName = "edge";
   } else {
      browserName = "No browser detection";
   }
   return browserName === "safari";
}

export const callMobileNumber = (number) => {
   window.location.href = `tel:${number}`;
};
export const sendMail = (mail) => {
   window.location.href = `mailto:${mail}`;
};
export const openLink = (url) => {
   window.open(url, "_blank");
};

export const checkLoved = (love, provId) => {
   if (love === null || love === undefined) return false;
   else
      return love.some((find) => {
         return find === provId;
      });
};

export const checkMediaType = (contentType, textVal = false) => {
   let validMedia = false;
   if (contentType?.includes("audio")) validMedia = true;
   if (contentType?.includes("video")) validMedia = true;
   if (contentType?.includes("image")) validMedia = true;
   if (contentType?.includes("pdf")) validMedia = true;
   if (!contentType?.includes("referral")) validMedia = true;
   if (textVal && (contentType?.includes("text") || contentType?.includes("item"))) validMedia = false;
   return validMedia;
};
export const successMessage = (message) => {
   toast(<ToastView text={message} />, defaultToastProps);
};

export const sendMessageSuccess = () => {
   toast(<ToastView text={texts.textSentSuccessful} />, defaultToastProps);
};

export const sendReferralSuccess = () => {
   toast(<ToastView text={texts.referralSentSuccessful} />, defaultToastProps);
};

export const ErrorMessage = (message) => {
   toast(
      <ToastView text={message.settings?.message || message.data?.settings?.message} type="error" />,
      defaultToastProps
   );
};

export const getDateFormatFromTimeStamp = (date) => {
   if (date === null || date === undefined || date === "") return "--/--/----";
   else return moment(date).format("MM/DD/YYYY");
};
export const getHospitalName = (hospitals) => {
   return hospitals !== null && hospitals !== undefined && hospitals?.length > 0 ? hospitals[0]?.name : "";
};

export const removeExtraSpace = (str) => {
   return str.replace(/\s+/g, " ").trim();
};

export const getAboutYouInfo = (obj) => {
   if (obj !== null && obj !== undefined && obj?.length > 0) {
      return { id: obj[0]?.id, name: obj[0]?.name };
   } else {
      return false;
   }
};

export const errorToDisplay = (err) => {
   if (Array.isArray(err?.networkError?.result?.errors) && err?.networkError?.result?.errors?.length > 0) {
      let errMessage = err?.networkError?.result?.errors[0]?.message;
      return errMessage;
   } else {
      return "Something went wrong!";
   }
};

export const isValidUrl = (url) => {
   return urlRegex.test(url);
};

export const isNumber = (num) => {
   if (!isNaN(num) && num.length >= 10) {
      return true;
   }
   return false;
};

export const getFilteredFiles = (files) => {
   var arr = [];
   var message = "";
   for (let i = 0; i < files.length; i++) {
      if (
         allowedFormats.some((some) => {
            return files[i]?.type?.includes(some?.toLowerCase());
         })
      ) {
         arr.push(files[i]);
      } else {
         message = `${files[i].name}  ${message.length > 0 ? " , " + message : message}`;
      }
   }
   message = message.length > 40 ? message.substring(0, 40) + "..." : message;
   if (files.length > arr.length) {
      ShowAlert(message + " " + data.onboarding.filesError, "error");
   }
   return arr || [];
};

export const getWidgetsTitle = (cardId, loggedInProviderDetails) => {
   switch (cardId) {
      case "myPatients":
         return "My Patients";
      case "viewedPatients":
         return "Viewed";
      case "appointments":
         return "Appointments";
      case "inpatients":
         return "Inpatients";
      case "outpatients":
         return "Outpatients";
      case "myDepartmentPatients":
         const department =
            loggedInProviderDetails?.departmentObj?.length > 0
               ? loggedInProviderDetails?.departmentObj[0].name
               : loggedInProviderDetails?.departmentName
                  ? loggedInProviderDetails?.departmentName
                  : "";
         return department || "My Department";
      case "contentViewAnalytics":
         return "Content Views";
      default:
         return cardId;
   }
};
export const getWidgetsListTitle = (cardId) => {
   switch (cardId) {
      case "inpatients":
         return "Location";
      default:
         return "";
   }
};

export const getUnixTimeForCurrentDate = () => {
   let currentDate = new Date();
   return currentDate.valueOf();
};

export const appointmentData = (appointment = null, prevAppointment, NextAppointment) => {
   if (appointment) {
      const date = new Date(appointment?.startDateTime);
      let currentDate = moment().format("MM/DD/YYYY").toString();
      let oneDate = moment(date);
      let dayName = oneDate.format("dddd");
      let appointmentDate = moment(appointment?.startDateTime).format("MM/DD/YYYY").toString();
      let prevDate = prevAppointment ? moment(prevAppointment?.startDateTime).format("MM/DD/YYYY").toString() : null;
      let nextDate = moment(NextAppointment?.startDateTime).format("MM/DD/YYYY").toString();
      let diffInDays = Math.abs(moment().diff(date, "days"));
      let duration = moment.duration(moment(new Date()).diff(appointmentDate));
      let diffInHours = Math.abs(duration.asHours());
      let titleLabel = moment(date).format("MM/DD/YYYY");
      if ((diffInDays === 1 && diffInHours >= 24 && diffInHours <= 48) || (diffInDays > 1 && diffInDays <= 5)) {
         titleLabel = dayName;
      } else if (diffInDays === 0 && currentDate === appointmentDate) {
         titleLabel = "Today";
      } else if (diffInDays === 1 || (diffInDays === 0 && currentDate !== appointmentDate)) {
         titleLabel = "Tomorrow";
      } else if (diffInDays === 6 && dayName !== moment(new Date()).format("dddd")) {
         titleLabel = dayName;
      } else {
         titleLabel = moment(date).format("MM/DD/YYYY");
      }

      return {
         showDotted: nextDate === appointmentDate,
         showTitle: appointmentDate === prevDate ? false : true,
         isRead: appointment.status !== "read",
         titleLabel: titleLabel,
         currentApptDate: appointmentDate,
         prevApptDate: prevDate,
         nextApptDate: nextDate,
      };
   }
};
export const clearConsole = () => {
   if (process.env.NODE_ENV === "production") {
      console.clear();
   }
};

export const checkForUrlParams = (param, value) => {
   let urlParams = new URLSearchParams(window.location.search);
   if (urlParams.get(param) === value.toString()) return true;
   return false;
};

export const checkAndGetUrlParams = (param) => {
   let urlParams = new URLSearchParams(window.location.search);
   if (urlParams.get(param)) return urlParams.get(param);
   return false;
};

export const getBrowser = () => {
   var navigator = window.navigator;
   var nAgt = navigator.userAgent;
   var browserName = navigator.appName;

   // In Opera, the true version is after "Opera" or after "Version"
   if (nAgt.indexOf("Opera") !== -1) {
      browserName = "Opera";
   }
   // In MSIE, the true version is after "MSIE" in userAgent
   else if (nAgt.indexOf("MSIE") !== -1) {
      browserName = "Microsoft Internet Explorer";
   }
   // In Chrome, the true version is after "Chrome"
   else if (nAgt.indexOf("Chrome") !== -1) {
      browserName = "Chrome";
   }
   // In Safari, the true version is after "Safari" or after "Version"
   else if (nAgt.indexOf("Safari") !== -1) {
      browserName = "Safari";
   }
   // In Firefox, the true version is after "Firefox"
   else if (nAgt.indexOf("Firefox") !== -1) {
      browserName = "Firefox";
   }
   return browserName;
};
export const checkContentType = (type) => {
   if (type?.includes("application/pdf")) return "pdf";
   else {
      return `${type?.substring(0, type?.indexOf("/")) || type || ""}`;
   }
};

export const toProperCase = (str = "") => {
   if (str) {
      let nameArr = str?.split(",");
      let properString = nameArr[0]?.replace(/\w\S*/g, (txt) => {
         return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
      });
      if (nameArr[1]) {
         return properString + "," + nameArr[1];
      } else {
         return properString;
      }
   } else return "";
};

export const getDateFormatNewCards = (dateValue, isRecentCard = false) => {
   const date = new Date(dateValue);
   let oneDate = moment(date);
   let dayName = oneDate.format("dddd");
   let diffInDays = Math.round(moment().diff(dateValue, "days", true));
   if (diffInDays > 1 && diffInDays < 7) {
      return moment(date).format(isRecentCard ? "hh:mm A" : "hh:mm a");
   } else if (diffInDays === 0) {
      return (dayName = moment(date).format(isRecentCard ? "hh:mm A" : "hh:mm a"));
   } else if (diffInDays === 1) {
      return (dayName = "Yesterday");
   } else {
      return moment(date).format("MM/DD/YYYY");
   }
};

export const getAppointmentTime = (dateValue) => {
   const date = moment(dateValue).format("MM/DD/YYYY");
   let currentDate = moment(new Date()).format("MM/DD/YYYY").toString();
   let oneDate = moment(dateValue);
   let dayName = oneDate.format("dddd");
   let appointmentDate = moment(dateValue).format("MM/DD/YYYY").toString();
   let diffInDays = Math.abs(moment().diff(date, "days"));
   let duration = moment.duration(moment(new Date()).diff(appointmentDate));
   let diffInHours = Math.abs(duration.asHours());
   let titleLabel = moment(date).format("MM/DD/YYYY");
   if ((diffInDays === 1 && diffInHours >= 24 && diffInHours <= 48) || (diffInDays > 1 && diffInDays <= 5)) {
      titleLabel = dayName + " at " + moment(dateValue).format("h:mm a");
   } else if (diffInDays === 0 && currentDate === appointmentDate) {
      titleLabel = "Today" + " at " + moment(dateValue).format("h:mm a");
   } else if ((diffInDays === 0 && currentDate !== appointmentDate) || diffInDays === 1) {
      titleLabel = "Tomorrow" + " at " + moment(dateValue).format("h:mm a");
   } else if (diffInDays === 6 && dayName !== moment(new Date()).format("dddd")) {
      titleLabel = dayName + " at " + moment(dateValue).format("h:mm a");
   } else {
      titleLabel = moment(date).format("MM/DD/YYYY") + " at " + moment(dateValue).format("h:mm a");
   }
   return titleLabel;
};

export const getTimeDifference = (date1, date2, time) => {
   let a = moment(date1);
   let b = moment(date2);
   return a.diff(b, time ? time : "seconds"); // 1
};
export const makeFirstLetterCapital = (event, callback = () => { }, elementId) => {
   let val = event.target.value;
   val = val.substring(0, 1).toUpperCase() + val.substring(1);
   const rightCharsCount = val.length - event.target.selectionEnd;
   const newPosition = val.length - rightCharsCount;
   setTimeout(() => {
      elementId?.setSelectionRange(newPosition, newPosition);
   }, 0);
   callback(val);
};

export const makeSentenceCapital = (event, callback = () => { }, elementId) => {
   let val = event.target.value;
   let arr = val.split(" ");
   if (arr.length <= 3) {
      for (let i = 0; i < arr.length; i++) {
         arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].substring(1);
      }
      arr = arr.join(" ");
      val = arr;
   } else {
      val = val.substring(0, 1).toUpperCase() + val.substring(1);
   }
   const rightCharsCount = val.length - event.target.selectionEnd;
   const newPosition = val.length - rightCharsCount;
   setTimeout(() => {
      elementId?.setSelectionRange(newPosition, newPosition);
   }, 0);
   callback(val);
};

export const dateConversionGlobal = (dateValue) => {
   const date = moment(dateValue).format("MM/DD/YYYY");
   let currentDate = moment(new Date()).format("MM/DD/YYYY").toString();
   let oneDate = moment(dateValue);
   let dayName = oneDate.format("dddd");
   let appointmentDate = moment(dateValue).format("MM/DD/YYYY").toString();
   let diffInDays = Math.abs(moment().diff(date, "days"));
   let duration = moment.duration(moment(new Date()).diff(appointmentDate));
   let diffInHours = Math.abs(duration.asHours());
   let titleLabel = moment(date).format("MM/DD/YYYY");
   if (diffInDays === 0 && currentDate === appointmentDate) {
      titleLabel = moment(dateValue).format("h:mm a");
   } else if ((diffInDays === 0 && currentDate !== appointmentDate) || diffInDays === 1) {
      titleLabel = "Yesterday";
   } else if (diffInDays === 6 && dayName !== moment(new Date()).format("dddd")) {
      titleLabel = dayName;
   } else if ((diffInDays === 1 && diffInHours >= 24 && diffInHours <= 48) || (diffInDays > 1 && diffInDays <= 5)) {
      titleLabel = dayName;
   } else {
      titleLabel = moment(date).format("MM/DD/YYYY");
   }
   return titleLabel;
};
export const dateConversionGlobalEpic = (dateValue) => {
   if (!dateValue) return ""
   const date = moment(dateValue).format("MM/DD/YYYY");
   let currentDate = moment(new Date()).format("MM/DD/YYYY").toString();
   let oneDate = moment(dateValue);
   let dayName = oneDate.format("dddd");
   let appointmentDate = moment(dateValue).format("MM/DD/YYYY").toString();
   let diffInDays = Math.abs(moment().diff(date, "days"));
   let duration = moment.duration(moment(new Date()).diff(appointmentDate));
   let diffInHours = Math.abs(duration.asHours());
   let titleLabel = moment(date).format("MM/DD/YYYY");
   if (diffInDays === 0 && currentDate === appointmentDate) {
      titleLabel = "Today at " + moment(dateValue).format("h:mm a");
   } else if ((diffInDays === 0 && currentDate !== appointmentDate) || diffInDays === 1) {
      titleLabel = "Yesterday at " + moment(dateValue).format("h:mm a");
   } else if (diffInDays === 6 && dayName !== moment(new Date()).format("dddd")) {
      titleLabel = dayName + " at " + moment(dateValue).format("h:mm a");
   } else if ((diffInDays === 1 && diffInHours >= 24 && diffInHours <= 48) || (diffInDays > 1 && diffInDays <= 5)) {
      titleLabel = dayName + " at " + moment(dateValue).format("h:mm a");
   } else {
      titleLabel = moment(date).format("MM/DD/YYYY") + " at " + moment(dateValue).format("h:mm a");
   }
   return titleLabel;
};

export const isMobileScreen = () => {
   const ua = navigator.userAgent || navigator.vendor || window.opera;

   // Basic UA checks
   if (/android/i.test(ua)) return true;
   if (/iPhone|iPad|iPod/i.test(ua)) return true;

   // iPadOS 13+ using macOS-like UA
   const isIpadOS13Plus = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

   if (isIpadOS13Plus) return true;

   // Fallback for very small screens
   if (window.innerWidth < 768) return true;

   return false;
};

export const isMobile = () => {
   return (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
      navigator.userAgent.match(/Opera Mini/i) ||
      window.innerWidth <= 768
   );
};

export const isAndroidDevice = () => {
   return navigator.userAgent.match(/Android/i);
};

export const checkforWebCam = async () => {
   //Check if there is any video device
   let videoDeviceArr = [];
   let res = await navigator.mediaDevices.enumerateDevices();
   videoDeviceArr = res.filter((device) => device.kind === "videoinput");
   return videoDeviceArr;
};

export const checkUrlAccessible = async (url) => {
   return new Promise((resolve, reject) => {
      try {
         // Make a GET request to the URL
         axios.get(url, (res) => {
            // Check the response status code
            if (res.statusCode === 200) {
               console.log(`The URL ${url} has data.`);
               return resolve(true);
            } else {
               console.log(`The URL ${url} does not have data.`);
               return resolve(false);
            }
         });
      } catch (error) {
         console.log("RTrytu");
         reject(false);
      }
   });
};

// export const checkUrlAccessible = (url) => {
//    return new Promise(async (res, rej) => {
//       await axios
//          .get(url)
//          .then((response) => {
//             if (response.status === 200) {
//                res(true);
//             } else {
//                rej(false);
//             }
//          })
//          .catch((err) => {
//             rej(false);
//          });
//    });
// };

export const getAgeFromSelectedDate = (date) => {
   // Step 1: Parse the date string to obtain a JavaScript Date object
   const birthDate = new Date(date);
   // Step 2: Get the current date as a JavaScript Date object
   const currentDate = new Date();
   // Step 3: Calculate the time difference in milliseconds
   const timeDifferenceMs = currentDate - birthDate;
   // Step 4: Convert milliseconds to years
   const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25; // Taking into account leap years
   const ageInYears = Math.floor(timeDifferenceMs / millisecondsInYear);
   return ageInYears;
};

export const downloadVideo = (data) => {
   const dataURL = data;
   const anchor = document.createElement("a");
   anchor.href = dataURL;
   anchor.download = "downloaded-video.webm";
   anchor.click();
};

export const checkSpecificPermission = async (callback = () => { }, name = "", errorCallback = () => { }) => {
   try {
      const microphonePermission = await navigator.permissions.query({ name: name });
      if (microphonePermission.state === "granted") {
         callback();
      } else {
         errorCallback();
      }
   } catch (error) {
      errorCallback();
   }
};

export const checkSpecificPermissionCreateContent = async (callback = () => { }, errorCallback = () => { }) => {
   try {
      navigator.mediaDevices
         .getUserMedia({
            audio: true,
         }).then(() => {
            callback();
         }).catch(() => {
            errorCallback();
         })
   } catch (error) {
      errorCallback();
   }
};

export const checkPermissionsForVideo = async (callback = () => { }, errorCallback = () => { }) => {
   try {
      // Check microphone permission
      const microphonePermission = await navigator.permissions.query({ name: "microphone" });
      const cameraPermission = await navigator.permissions.query({ name: "camera" });

      if (microphonePermission.state === "granted" && cameraPermission.state === "granted") {
         callback();
      } else {
         errorCallback();
      }
   } catch (error) {
      errorCallback();
   }
};



export const formatPhoneNumberNewAppV2 = (number, code) => {
   if (!number) {
      return "-";
   }
   // Convert the number to string
   var numberStr = number.toString();

   // Check if the number has 10 digits
   if (numberStr.length !== 10 && numberStr.length !== 11 && numberStr.length !== 12) {
      return "-";
   }
   if (numberStr.length === 11) {
      // Extract the country code and the rest of the number
      const countryCode = numberStr.substring(0, 1);
      const restOfNumber = numberStr.substring(1);

      let formattedNumber = "";
      if (code === "+55") {
         formattedNumber =
            "-" + numberStr.substring(0, 2) + "-" + numberStr.substring(2, 7) + "-" + numberStr.substring(7);
      } else {
         formattedNumber =
            "+" +
            countryCode +
            "-" +
            restOfNumber.substring(0, 3) +
            "-" +
            restOfNumber.substring(3, 6) +
            "-" +
            restOfNumber.substring(6);
      }

      return formattedNumber;
   }
   if (numberStr.length === 10 && code === "+57") {
      let formattedNumber = "";
      formattedNumber = +numberStr.substring(0, 3) + "-" + numberStr.substring(3, 8);
      return formattedNumber;
   }
   // Format the number
   var formattedNumber = numberStr.substring(0, 3) + "-" + numberStr.substring(3, 6) + "-" + numberStr.substring(6);

   return formattedNumber;
};

export const isNumberContainsCountryCode = (number) => {
   let arr = ["+91", "+1", "+55", "+34", "+57"];
   return arr.some((find) => {
      return number?.trim()?.startsWith(find);
   });
};

export const formatPhoneNumberAllCountry = (number) => {
   // Remove any non-digit characters from the input
   const cleaned = ("" + number).replace(/[^\d+]/g, "");

   // Check if the cleaned number has at least 10 digits
   if (cleaned.length < 10) {
      return "";
   }

   // Extract the last 10 digits for formatting
   const lastTenDigits = cleaned.slice(-10);

   // Format the extracted 10 digits
   const formattedNumber = `${cleaned.slice(0, -10)} ${cleaned.slice(-10, -12)} ${lastTenDigits.slice(
      0,
      3
   )}-${lastTenDigits.slice(3, 6)}-${lastTenDigits.slice(6)}`;

   return formattedNumber;
};

export const cleanPhoneNumber = (number) => {
   return number.replace(/[^\d+]/g, "");
};

export const copyToClipboard = (link) => {
   if (link) {
      navigator.clipboard
         .writeText(link)
         .then(() => {
            ShowAlert("Copied to clipboard.");
         })
         .catch((error) => ShowAlert("Failed to copy:", error));
   }
};

export function isWebView() {
   const ua = navigator.userAgent || navigator.vendor || window.opera;

   // Examples: LinkedIn, Facebook, Instagram webviews
   return (
      ua.includes("FBAN") ||
      ua.includes("FBAV") ||
      ua.includes("Instagram") ||
      ua.includes("LinkedIn") ||
      window.ReactNativeWebView !== undefined // RN Webview
   );
}

export const sendMailExternal = ({ email = "support@playbackhealth.com", subject = "", body = "" }) => {
   window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}